import React from 'react';
import Raven from 'raven-js';


export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);

        this.state = {error: false};
    }

    componentDidCatch(error, info) {
        //catch and send error to sentry.io if prod environment

        if(process.env.NODE_ENV !== 'development') {
            this.setState({error: true});
            Raven.captureException(error, { extra: info });
        }

    }

    render() {
        if (this.state.error) {
            return (
                <div className="error-page">
                    <div className="text">
                        <h2>Something's gone wrong</h2>
                        <p>Our team has been notified</p>
                    </div>
                </div>
            );
        } else {
            return this.props.children;
        }
    }
}






// WEBPACK FOOTER //
// ./src/components/commonComponents/util/ErrorBoundary.jsx